<div class="device-panel">
    <!-- Readonly Mode -->
    <div class="readonly-view">
        <div class="panel-content" *ngIf="device as details">
            <div class="box">
                <div class="title">
                    <h5>{{ 'FEATURES.DEVICE.NAME' | translate }}</h5>
                </div>
                <p>{{ details.serialNumber }}</p>
                <p>{{ details.softwareVersion }}</p>
            </div>

            <div *appHasPermissions="[permissions.WriteFirmware]" class="box calibration-details">
                <dl class="calibration-group">
                    <div>
                        <dt>
                            <h5>{{ 'FEATURES.DEVICE.PREVIOUS_CALIBRATION_STATUS' | translate }}</h5>
                        </dt>
                        <dd>
                            {{
                                'FEATURES.DEVICE.CALIBRATION_STATUSES.' + details.deviceCalibrationStatusId | translate
                            }}
                        </dd>
                    </div>
                    <div>
                        <dt>
                            <h5>{{ 'FEATURES.DEVICE.CURRENT_CALIBRATION_STATUS' | translate }}</h5>
                        </dt>
                        <dd>
                            {{
                                details.calibration
                                    ? ('FEATURES.DEVICE.CALIBRATION_STATUSES.' + details.calibration.statusId
                                      | translate)
                                    : '-'
                            }}
                        </dd>
                    </div>
                    <div>
                        <dt>
                            <h5>{{ 'FEATURES.DEVICE.DRIFT_PPM' | translate }}</h5>
                        </dt>
                        <dd>{{ (details.calibration?.driftPPM | number: '1.0-2') ?? '-' }}</dd>
                    </div>
                </dl>
                <dl class="calibration-group">
                    <div>
                        <dt>
                            <h5>{{ 'FEATURES.DEVICE.DEVICE_DATETIME_REF_ONE' | translate }}</h5>
                        </dt>
                        <dd>{{ (details.calibration?.deviceDateTimeRefOne | date: 'yyyy-MM-dd HH:mm:ss') ?? '-' }}</dd>
                    </div>
                    <div>
                        <dt>
                            <h5>{{ 'FEATURES.DEVICE.REQUESTED_AT_REF_ONE' | translate }}</h5>
                        </dt>
                        <dd>
                            {{
                                (details.calibration?.deviceDateTimeRequestedAtRefOne | date: 'yyyy-MM-dd HH:mm:ss') ??
                                    '-'
                            }}
                        </dd>
                    </div>
                </dl>
                <dl class="calibration-group">
                    <div>
                        <dt>
                            <h5>{{ 'FEATURES.DEVICE.DEVICE_DATETIME_REF_TWO' | translate }}</h5>
                        </dt>
                        <dd>{{ (details.calibration?.deviceDateTimeRefTwo | date: 'yyyy-MM-dd HH:mm:ss') ?? '-' }}</dd>
                    </div>
                    <div>
                        <dt>
                            <h5>{{ 'FEATURES.DEVICE.REQUESTED_AT_REF_TWO' | translate }}</h5>
                        </dt>
                        <dd>
                            {{
                                (details.calibration?.deviceDateTimeRequestedAtRefTwo | date: 'yyyy-MM-dd HH:mm:ss') ??
                                    '-'
                            }}
                        </dd>
                    </div>
                </dl>
                <button
                    *ngIf="details.calibration"
                    type="button"
                    class="btn delete-calibration"
                    (click)="confirmClearCalibration()"
                    [disabled]="clearingCalibration"
                >
                    <span class="material-symbols-rounded" aria-hidden="true">delete</span>
                    {{ 'FEATURES.DEVICE.CLEAR_CALIBRATION' | translate }}
                </button>
            </div>

            <div class="box">
                <div class="title">
                    <span class="material-symbols-rounded" aria-hidden="true">files</span>
                    <h5>{{ 'FEATURES.DEVICE.LOGFILES' | translate }}</h5>
                </div>

                <ul class="log-files-list">
                    <li *ngFor="let logFile of details.deviceFiles">
                        <span class="log-file-name">log file</span>
                        <span class="log-file-name">{{ logFile.created | date: 'yyyy-MM-dd HH:mm' }}</span>
                        <button
                            *appHasPermissions="[permissions.InternalUser]"
                            type="button"
                            class="btn-download"
                            (click)="downloadLogFile(logFile)"
                            [title]="'Download ' + logFile.filename"
                        >
                            <span class="material-symbols-rounded" aria-hidden="true">download</span>
                        </button>
                    </li>
                </ul>
            </div>

            <div class="box">
                <div class="title">
                    <span class="material-symbols-rounded" aria-hidden="true">location_on</span>
                    <h5>{{ 'FEATURES.DEVICE.LOCATIONS' | translate }}</h5>
                </div>

                <ul class="locations-list">
                    <li *ngFor="let location of details.locations">
                        <span class="location-name">{{ location.name }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
